import React, { useState } from "react";

export const isSandboxEnv =
  String(process.env.REACT_APP_ENV || "")
    .trim()
    .toLowerCase() === "sandbox";

const SANDBOX_HINT = "This is a sandbox server. Data here is not production.";

const InfoIcon = () => (
  <svg
    width='13'
    height='13'
    viewBox='0 0 13 13'
    fill='none'
    aria-hidden='true'
    className='block shrink-0'>
    <circle cx='6.5' cy='6.5' r='5.25' stroke='currentColor' strokeWidth='1.25' />
    <path
      d='M6.5 5.75v3.25M6.5 4h.01'
      stroke='currentColor'
      strokeWidth='1.35'
      strokeLinecap='round'
    />
  </svg>
);

const InfoHint = () => {
  const [open, setOpen] = useState(false);

  return (
    <span
      className='relative inline-flex items-center'
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}>
      <button
        type='button'
        aria-label={SANDBOX_HINT}
        className='inline-flex h-[13px] w-[13px] items-center justify-center text-[#C45C12] opacity-80 hover:opacity-100'>
        <InfoIcon />
      </button>
      {open && (
        <span
          role='tooltip'
          className='absolute left-1/2 top-full z-50 mt-1.5 w-max max-w-[200px] -translate-x-1/2 rounded-md bg-grey-900 px-2.5 py-1.5 text-left text-[11px] font-normal normal-case leading-snug tracking-normal text-white shadow-lg'>
          {SANDBOX_HINT}
        </span>
      )}
    </span>
  );
};

export const SandboxBadge = ({ collapsed = false }) => {
  if (!isSandboxEnv) return null;

  if (collapsed) {
    return (
      <div className='mb-2 flex justify-center'>
        <InfoHint />
      </div>
    );
  }

  return (
    <div className='mb-2 flex justify-center px-3'>
      <div className='inline-flex items-center gap-1 text-[12px] font-medium leading-none text-[#C45C12]'>
        <span>Sandbox</span>
        <InfoHint />
      </div>
    </div>
  );
};
